/* eslint-disable max-len */
import { createSvgIcon } from "../utils";

const ChevronDown = createSvgIcon(
    <path d="M8.306 12.306a1.043 1.043 0 011.475 0L16 18.524l6.219-6.218a1.043 1.043 0 011.475 1.475l-6.956 6.957a1.044 1.044 0 01-1.476 0L8.306 13.78a1.043 1.043 0 010-1.475z" />,
    "ChevronDown",
);

export default ChevronDown;
